import { useRef, useEffect } from 'react'
import Button from '../Button.jsx'
import Field from '../form/Field.jsx'
import Hidden from '../form/Hidden.jsx'
import { ThirdPartyApiList } from '../../repo/ThirdPartyApiRepo'

export default function AdminTournamentsForm({tournament, errors, isSubmitting}) {
  const idRef = useRef()
  const nameRef = useRef()
  const editionRef = useRef()
  const startsAtRef = useRef()
  const endsAtRef = useRef()
  const thirdPartyLabelRef = useRef()
  const thirdPartyIdRef = useRef()
  const thirdPartySeasonRef = useRef()
  const tournamentStandingsRulesRef = useRef()
  const tournamentStandingsContentRef = useRef()

  useEffect(() => {
    if (tournament) {
      idRef.current.value = tournament.id;
      nameRef.current.value = tournament.name;
      editionRef.current.value = tournament.edition;
      startsAtRef.current.value = tournament.starts_at;
      endsAtRef.current.value = tournament.ends_at;
      thirdPartyLabelRef.current.value = tournament.third_party_label;
      thirdPartyIdRef.current.value = tournament.third_party_id;
      thirdPartySeasonRef.current.value = tournament.third_party_season;
      tournamentStandingsRulesRef.current.value = JSON.stringify(tournament.tournament_standings.rules);
      tournamentStandingsContentRef.current.value = JSON.stringify(tournament.tournament_standings.content);
    }
  }, [tournament]);

  function nameHasError() {
    if (errors && errors.name) {
      return "Nome inválido"
    }

    return ""
  }

  function editionHasError() {
    if (errors && errors.edition) {
      return "Edição inválida"
    }

    return ""
  }

  function startsAtHasError() {
    if (errors && errors.starts_at) {
      return "Data de início inválida"
    }

    return ""
  }

  function endsAtHasError() {
    if (errors && errors.ends_at) {
      return "Data de término inválida"
    }

    return ""
  }

  return(
    <>
      <Field type={"input"} ref={nameRef} name={"name"} id={"name"} label={"Nome"} required={""} disabled={isSubmitting} error={nameHasError()}/>
      <Field type={"input"} ref={editionRef} name={"edition"} id={"edition"} label={"Edição"} required={""} disabled={isSubmitting} error={editionHasError()}/>
      <Field type={"input"} ref={startsAtRef} name={"starts_at"} id={"starts_at"} label={"Início em"} required={""} disabled={isSubmitting} error={startsAtHasError()}/>
      <Field type={"input"} ref={endsAtRef} name={"ends_at"} id={"ends_at"} label={"Termina em"} required={""} disabled={isSubmitting} error={endsAtHasError()}/>

      <Field
        type={"select"}
        name={"third_party_label"}
        id={"third_party_label"}
        label={"API de Terceiros"}
        required={""}
        options={ThirdPartyApiList()}
        defaultValue={''}
        disabled={isSubmitting}
        ref={thirdPartyLabelRef}/>

      <Field
        type={"input"}
        name={"third_party_id"}
        id={"third_party_id"}
        label={"ID de Terceiros"}
        required={""}
        disabled={isSubmitting}
        ref={thirdPartyIdRef}/>

      <Field
        type={"input"}
        name={"third_party_season"}
        id={"third_party_season"}
        label={"Edição de Terceiros"}
        required={""}
        disabled={isSubmitting}
        ref={thirdPartySeasonRef}/>

      <Field
        type={"textarea"}
        name={"tournament_standings_rules"}
        id={"tournament_standings_rules"}
        label={"Regras (filters and replacements) para classificação"}
        required={""}
        disabled={isSubmitting}
        ref={tournamentStandingsRulesRef}
        rows={8}
        />

      <Field
        type={"textarea"}
        name={"tournament_standings_content"}
        id={"tournament_standings_content"}
        label={"Conteúdo da Classificação"}
        required={""}
        disabled={isSubmitting}
        ref={tournamentStandingsContentRef}
        rows={8}
        />

      {tournament && tournament.id && (
        <Hidden ref={idRef} name={"id"} id={"id"} />
      )}
      <Button styleName="blue" disabled={isSubmitting} >
        {isSubmitting ? 'Saving...' : 'Save'}
      </Button>
    </>
  )
}
